import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function DeleteAlert(props) {
  const { deleteAlert, handleDeleteAlert } = props

  return (
    <React.Fragment>

      <Dialog
        open={deleteAlert["open"]}
        onClose={() => { handleDeleteAlert("close", null) }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`حذف زیرنویس ردیف ${deleteAlert["subIndex"] + 1}`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`آیا شما مطمئن هستید که میخواهید زیر نویس ردیف ${deleteAlert["subIndex"] + 1} را حذف کنید`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { handleDeleteAlert("close", null) }} autoFocus>لغو</Button>
          <Button onClick={() => { handleDeleteAlert("deleteSub", null) }} >
            تایید
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}